import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WhoWeAreSection.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const WhoWeAreSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  return (
    <section className="who-we-are" ref={ref}>
      <Container>
        <Row className="">
          {/* Left Content */}
          <Col
            lg={6}
            sm={12}
            md={6}
            className="left-content order-2 order-md-1"
          >
            <h2 className="section-title">
              Who <span>We Are</span>
            </h2>

            <p className="description">
              We are a career focused technology training and IT solutions
              organization dedicated to transforming learners into highly
              skilled, job-ready professionals. With deep expertise in Data
              Engineering, Data Analytics, Cloud, and modern data technologies,
              we bridge the gap between theoretical learning and real world
              industry execution.
            </p>

            <h4 className="growth-title">Measuring Our Growth</h4>

            <div className="growth-box">
              <div>
                <h5>
                  {inView && <CountUp
                    end={2000}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                  />}
                  +
                </h5>
                <p>Learners</p>
              </div>

              <div>
                <h5>
                  {inView && <CountUp
                    end={300}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                  /> }
                  +
                </h5>
                <p>Hiring Partners</p>
              </div>

              <div>
                <h5>
                  {inView && <CountUp
                    start={7}
                    end={12}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                  /> }
                  +
                </h5>
                <p>Yr Expert Mentors</p>
              </div>

              <div>
                <h5>
                 {inView && <CountUp
                    end={50}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                  /> }
                  +
                </h5>
                <p>Projects</p>
              </div>

              <div>
                <h5>
                 {inView && <CountUp
                    end={90}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                  /> }
                  %
                </h5>
                <p>Career Growth</p>
              </div>
            </div>
          </Col>

          {/* Right Image */}
          <Col lg={6} sm={12} md={6} className="right-image order-1 order-md-2">
            <img
              src="/assets/images/pst_it_solution/banner/img-2.png"
              alt="Students"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhoWeAreSection;
